import Surveys from '../surveys/Surveys.vue';
import Notifications from '../notifications/Notifications.vue';
import Carousel from '../../../sharedComponents/carousel/Carousel.vue';
import WidgetSales from '../../../components/widget-sales/WidgetSales.vue';
import WidgetRating from '../../../components/widget-rating/WidgetRating.vue';

export default {
  data() {
    return {
      pagePers: null,
      pageRules: null,
      dialogPers: false,
      dialogRules: false,
      checkedRules: false,
      checkedPers: false,
    };
  },
  components: {
    Surveys,
    Notifications,
    Carousel,
    WidgetSales,
    WidgetRating,
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    purses() {
      return this.$store.state.purses;
    },
    requirePers() {
      const { state } = this.$store;
      return !!(
        state.settings.profile_pers === true
          && state.user
          && !state.user.pers_at
      );
    },
    requireRules() {
      const { state } = this.$store;
      return !!(
        state.settings.profile_rules === true
        && state.user
        && this.$store.state.agreedRules === false
      );
    },
    account() {
      return this.$store.state.user.account;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    userIsChecked() { return this.$store.state.user ? this.$store.state.user.is_checked : null; },
    isBlocked() {
      return !!(this.$store.state.user
        && this.$store.state.user.blocked_at !== null);
    },
    hasSurvey() {
      return this.$store.state.surveys.hasSurvey;
    },
    hasNotifications() {
      return this.$store.state.notifications.hasNotifications;
    },
    isBannersOn() {
      return this.$store.state.settings.module_banners === true;
    },
    settings() {
      return this.$store.state.settings;
    },
    banners() {
      return this.$store.state.banners.bannersList || [];
    },
    taxes() {
      return this.$store.state.settings.taxes === true;
    },
    actions() {
      return this.$store.state.sales.actions;
    },
    salesCount() {
      return this.$store.state.sales.sales.length || 0;
    },
    rating() { return this.$store.state.rating.rating || []; },
    loading() { return this.$store.state.loading; },
  },
  methods: {
    CheckPers() {
      this.dialogPers = true;
      console.log(this.dialogPers);
    },

    IsRemoteUrl(url) {
      return (url.indexOf('://') !== -1);
    },
    ConfirmPers() {
      const app = this;
      app.$store.getters.axl.post('profiles/api/auth/confirm-pers', { profile_id: app.user.profile_id })
        .then(() => {
          this.$store.dispatch('GetProfile');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    LoadPers() {
      const app = this;
      app.$store.getters.ax.post('profiles/api/register/info', { phone: app.user.phone_mobile })
        .then((response) => {
          app.pagePers = response.data.pagePers;
          app.pageRules = response.data.pageRules;
        });
    },
    ConfirmRules() {
      this.$store.dispatch('AgreeingRules');
    },
  },
  created() {
    !this.user && this.$store.dispatch('GetProfile');
    !this.settings && this.$store.dispatch('GetSettings');
    this.isBannersOn && this.$store.dispatch('banners/GetBannersList');
  },
  mounted() {
    this.LoadPers();
  },
  watch: {
    user() {
      if (this.user) {
        this.$store.dispatch('surveys/GetSurveys', this.user.profile_id);
        this.$store.dispatch('news/GetUnreadNewsCount', this.user.profile_id);
        this.$store.dispatch('sales/GetObjects', { profile_id: this.user.profile_id });
        this.$store.dispatch('notifications/GetNotifications', this.user.profile_id);
        this.$store.dispatch('rating/GetRating', this.user.profile_id);
        this.$store.dispatch('CheckAgreedRules').then(() => {
          if (this.requirePers || this.requireRules) {
            this.LoadPers();
          }
        });
      }
    },
  },
};
